import { pickDefaultModel, providerBase } from './modelConstants';
import { isUsableProviderConfig } from './userPageHelpers';

// Which model field a provider key gets, everywhere a model is picked
// (ModelSelect): the platform's aliases, a local device's installed
// models, free text with suggestions for Azure and AWS (whose names
// are the user's own deployments and model ids), or a dropdown of the
// platform catalog plus the user's custom models.
export const modelFieldKind = (providerKey) => {
  const base = providerBase(providerKey || '');
  if (base === 'stackform' || base === 'default') return 'platform';
  if (base === 'local') return 'local';
  if (base === 'aws' || base === 'azure') return 'typed';
  return 'list';
};

// The model a newly picked provider key starts on: the recommended one in
// the list its model field shows, else the first ('' for an empty list).
// `modelLists` is what the field lists (useModelSettings().modelLists).
export const defaultModelFor = (providerKey, modelLists = {}) =>
  pickDefaultModel(providerKey, providerBase(providerKey), {
    catalog: modelLists.catalog,
    availableModels: modelLists.availableModels,
    localProviderModels: modelLists.localModels,
    modelRecommended: modelLists.recommended,
  });

// Each usable local config's installed models, by provider key ("local",
// "local_2"), from the user's Connect devices (GET /connect/devices): a
// config names its device, and an offline or unknown device lists none.
export const deviceModelsByKey = (providerConfigs = {}, devices = []) => {
  const installed = {};
  (devices || []).forEach((device) => {
    if (device?.device_name && Array.isArray(device.installed_models)) {
      installed[device.device_name] = device.installed_models;
    }
  });
  const byKey = {};
  (providerConfigs?.local || [])
    .filter((cfg) => isUsableProviderConfig('local', cfg))
    .forEach((cfg) => {
      const index = cfg.config_index ?? 1;
      const key = index === 1 ? 'local' : `local_${index}`;
      byKey[key] = (cfg.config_name && installed[cfg.config_name]) || [];
    });
  return byKey;
};
